import { LegacySwedishPuzzleModel } from './legacy-swedish-game.model';

export class LegacyPersistUserInput {
  static readonly type = '[SwedishGame] Persist userInput';
  constructor(public payload: { puzzleID: string; userInput: Array<string> }) {}
}

export class LegacyInitSwedishGame {
  static readonly type = '[SwedishGame] Init';
  constructor(public payload: LegacySwedishPuzzleModel) {}
}
